import { Measure, Unit } from "convert-units";

export type FlowUnits = FlowMetricUnits | FlowImperialUnits;
export type FlowSystems = "metric" | "imperial";

export type FlowMetricUnits = "L/min";
export type FlowImperialUnits = "gpm";

const metric: Record<FlowMetricUnits, Unit> = {
  "L/min": {
    name: {
      singular: "",
      plural: "",
    },
    to_anchor: 1,
  },
};

const imperial: Record<FlowImperialUnits, Unit> = {
  gpm: {
    name: {
      singular: "",
      plural: "",
    },
    to_anchor: 1,
  },
};

const measure: Measure<FlowSystems, FlowUnits> = {
  systems: {
    metric,
    imperial,
  },
  anchors: {
    metric: {
      imperial: {
        ratio: 3.785_412,
      },
    },
    imperial: {
      metric: {
        ratio: 0.264_172,
      },
    },
  },
};

export default measure;
